/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   agm-map[_ngcontent-%COMP%]{height:400px}[_nghost-%COMP%]   button.mat-accent[_ngcontent-%COMP%], [_nghost-%COMP%]   button.mat-primary[_ngcontent-%COMP%]{background-color:#182365}"];
export { styles as styles };
